module.exports = __webpack_public_path__ + "img/commitment2.80198482.svg";